import nextSvg from '../../../assets/svg/angle-right.svg';
import prevSvg from '../../../assets/svg/angle-left.svg'


const getEmptySlide = ( imageSrc ) => {
	const src = imageSrc || '';

	return `<article class="products type-products status-publish hentry product_type-credit-cards excerpt excerpt--products credit-slide credit-finder-slide swiper-slide">
		<figure class="excerpt__product"><picture><img loading="lazy" src="${src}" alt=""></picture></figure>
		<div class="excerpt__wrap">
			<h4 class="excerpt__title">Your search did not yield a result.</h4>
			<div class="excerpt__content">
				<div class="excerpt__excerpt">
					<p>We invite you to explore our range of credit cards and find the one most suitable for you.</p>
				</div>
			</div>
		</div>
	</article>`;
};

const CreditSwiper = function( slider ) {
	if ( ! slider ) {
		return;
	}

	let updatingFilters = false;

	const slideHasTerm = ( tokens, term ) => {
		if ( ! term ) {
			return true;
		}

		return tokens.includes( term );
	};

	const matchesGoal = ( slide, goal ) => {
		return ! goal || 'view-all' === goal || slideHasTerm( slide.goals, goal );
	};

	const initSelect2 = () => {
		if ( ! window.jQuery || ! $.fn.select2 ) {
			return;
		}

		$( slider ).closest( '.page-header, body' ).find( '.form-control.creditdrp' ).each( function() {
			if ( ! $( this ).hasClass( 'select2-hidden-accessible' ) ) {
				$( this ).select2( {
					width:       '100%',
					placeholder: 'All Card Features',
					allowClear:  false,
					templateResult: function( data ) {
						if ( data.disabled ) {
							return null;
						}

						return data.text;
					},
				} );
			}
		} );
	};

	const updateFeatureOptions = ( slideSources ) => {
		updatingFilters = true;

		const $select      = $( '.creditdrp' );
		const goal         = $("input[type='radio'][name='creditFinder']:checked").val();
		const features     = $( '.creditdrp' ).val() || [];

		const filtered = slideSources.filter( ( slide ) => {
			const matchesSelectedGoal = matchesGoal( slide, goal );
			const matchesFeatures     = ! features.length || features.every( ( feature ) => slideHasTerm( slide.features, feature ) );

			return matchesSelectedGoal && matchesFeatures;
		});

		$select.find( 'option' ).each( function() {
			const hasMatch = filtered.some( ( slide ) => slideHasTerm( slide.features, this.value ) );

			this.disabled = ! hasMatch;
			this.hidden   = ! hasMatch;

			if ( ! hasMatch ) {
				this.selected = false;
			}
		});

		if ( $select.hasClass( 'select2-hidden-accessible' ) ) {
			$select.trigger( 'change.select2' );
		}

		updatingFilters = false;
	};

	const refreshSlider = ( swiper, slideSources ) => {
		updateFeatureOptions( slideSources );

		const goal     = $( "input[type='radio'][name='creditFinder']:checked" ).val();
		const features = $( '.creditdrp' ).val() || [];
		const filtered = slideSources.filter( ( slide ) => {
			const matchesSelectedGoal = matchesGoal( slide, goal );
			const matchesFeatures     = ! features.length || features.every( ( feature ) => slideHasTerm( slide.features, feature ) );

			return matchesSelectedGoal && matchesFeatures;
		} );

		swiper.removeAllSlides();

		if ( filtered.length ) {
			filtered.forEach( ( slide ) => {
				swiper.appendSlide( slide.html );
			} );
		} else {
			swiper.appendSlide( getEmptySlide( slider.getAttribute( 'data-empty-image' ) ) );
		}

		swiper.update();
		swiper.slideTo( 0, 100, true );
	};

	const wrap   = slider.querySelector( '.credit-finder-slider__wrap' );
	const items  = slider.querySelector( '.credit-finder-slider__items' );
	const slides = Array.from( slider.querySelectorAll( '.credit-finder-slide' ) );

	if ( ! wrap || ! items ) {
		return;
	}

	wrap.classList.add( 'swiper-container' );
	items.classList.add( 'swiper-wrapper' );
	slides.forEach( ( feed ) => feed.classList.add( 'swiper-slide' ) );

	const slideSources = slides.map( ( elm ) => ( {
		html:     elm.outerHTML,
		goals:    ( elm.getAttribute( 'data-goals' ) || '' ).split( /\s+/ ).filter( Boolean ),
		features: ( elm.getAttribute( 'data-features' ) || '' ).split( /\s+/ ).filter( Boolean ),
	} ) );

	if ( 1 < slides.length ) {
		slider.insertAdjacentHTML(
			'beforeend',
			`<nav class="credit-finder__nav">
				<div class="credit-swiper-button-prev">${prevSvg}<span class= "credit-finder__pagination"><span class="swiper-pagination-current"></span></span></div>
				<div class="divider"></div>
				<div class="credit-swiper-button-next"><span class= "credit-finder__pagination"><span class="swiper-pagination-total"></span></span>${nextSvg}</div>
			</nav>`
		);
	}

	const swiper = new window.Swiper( wrap, {
		direction:           'horizontal',
		speed:               600,
		spaceBetween:        30,
		slidesPerView:       1,
		watchSlidesProgress: true,
		navigation:          {
			prevEl: slider.querySelector( '.credit-finder__nav .credit-swiper-button-prev' ),
			nextEl: slider.querySelector( '.credit-finder__nav .credit-swiper-button-next' ),
		},
		pagination: {
			el:                    '.credit-finder__pagination',
			type:                  'fraction',
			formatFractionCurrent: function ( number ) {
				return ( '0' + number ).slice( -2 );
			},
			formatFractionTotal: function ( number ) {
				return ( '0' + number ).slice( -2 );
			},
			renderFraction: function ( currentClass, totalClass ) {
				return '<span class="' + currentClass + '"></span>' +
					'<span class="' + totalClass + '"></span>';
			},
		},
		breakpoints: {
			700: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
			992: {
				slidesPerView: 1,
			},
		},
	} );

	$( '.creditdrp' ).on( 'select2:select select2:unselect', function() {
		if ( updatingFilters ) {
			return;
		}

		refreshSlider( swiper, slideSources );
	} );

	const radios = document.creditFinderForm && document.creditFinderForm.creditFinder;

	if ( radios ) {
		Array.from( radios ).forEach( ( radio ) => {
			radio.addEventListener( 'change', function() {
				refreshSlider( swiper, slideSources );
			} );
		} );
	}

	const applyInitialFilters = () => {
		initSelect2();
		updateFeatureOptions( slideSources );
	};

	if ( 'complete' === document.readyState ) {
		applyInitialFilters();
	} else {
		window.addEventListener( 'load', applyInitialFilters );
	}
};

CreditSwiper.instances = [].map.call( document.querySelectorAll( '.credit-finder-slider' ), ( node ) => CreditSwiper( node ) );

export default CreditSwiper;
